module.exports = __webpack_public_path__ + "static/media/mohan.6759a3dd.jpg";